<template>
  <div class="experiment ma-0">
    <v-row v-if="current.user_level=='ADMIN'">
      <v-col>
        <v-select
          :items="api.schools"
          :item-text="selectLabel('schools')"
          item-value="school_code"
          v-model="form.school_code"
          :label="selectLabel('label')"
          :disabled="current.user_level!='ADMIN'"
          @change="goTo(form.school_code)"
        ></v-select>
      </v-col>
    </v-row>
    <h4 class="my-5">{{ $t("booking.header") }}</h4>
    <div class='mt-5 mb-2 title d-flex'>

      <span><v-img width="30px" :src='api.school_logo_url' /></span>
      <span v-if="$i18n.locale=='tc'" class='ml-2'> {{ api.school_chname }} </span>
      <span v-else class='ml-2'> {{ api.school_enname }} </span>
      <span class="ml-auto">
        <v-btn color="light-green lighten-3" @click="dialog_calendar = true; componentKey+=1" disabled>
          <v-icon>mdi-calendar</v-icon>
          {{ $t("booking.calendar_btn") }}
        </v-btn>
      </span>
    </div>

    <v-row class="mx-3">
      <v-spacer></v-spacer>
      
    </v-row>
    <v-expansion-panels class="my-3" v-model="panel" multiple>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>{{ $t("booking.my_booking.expansion") }}</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">{{ $t("booking.my_booking.th_ref") }}</th>
                    <th class="text-left">{{ $t("booking.my_booking.th_experiment_set") }}</th>
                    <th class="text-left">{{ $t("booking.my_booking.th_from") }}</th>
                    <th class="text-left">{{ $t("booking.my_booking.th_to") }}</th>
                    <th class="text-left">{{ $t("booking.my_booking.th_status") }}</th>
                    <th class="text-left">{{ $t("booking.my_booking.th_action") }}</th>
                  </tr>            
                </thead>
                <tbody>
                  <tr v-for="(slot, index) in api.slots" :key="index" :class="{ override:isOverrided(slot) }">
                    <td><p>{{ slot.ref }}</p></td>
                    <td>
                      <p v-if="$i18n.locale=='tc'">{{ slot.experiment_set_chi }}</p>
                      <p v-else>{{ slot.experiment_set }}</p>
                    </td>
                    <td><p>{{ slot.start_at }}</p></td>
                    <td><p>{{ slot.end_at }}</p></td>
                    <td>
                      <p v-if="$i18n.locale=='tc'">{{ slot.status_chi }}</p>
                      <p v-else>{{ slot.status }}</p>
                    </td>
                    <td>
                      <v-btn
                        color="amber darken-2 white--text"
                        v-if="isBookedSoon(slot)"
                        @click="releaseSlot(slot.ref)"
                        rounded
                      >
                        {{ $t("booking.btn.cancel") }}
                      </v-btn>
                      <template v-if="isBookedByMe(slot)">
                        <v-icon v-if="(slot.eStatus=='HOLD' || slot.status=='SUSPENDED')" color="red" >mdi-alert-circle</v-icon>
                        <v-btn
                          color="primary"
                          @click="enterLab(slot.ref, slot.experiment, slot.equipment_id, 'player', slot.override, current.user_level)"
                          :disabled="slot.status=='SUSPENDED'"
                        >
                          {{ $t("booking.btn.enter_lab") }}
                        </v-btn>
                      </template>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel>
        <v-expansion-panel-header color="green lighten-5">
          <h5>{{ $t("booking.opened_experiment.expansion") }}</h5>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col>
            </v-col>
          </v-row>
          <v-data-table
            v-if="$i18n.locale=='tc'"
            :locale="localeTranslate()"
            dense 
            :headers="headers_book_slots_chi"
            :items="api.book_slots"
            item-key="id"
            :items-per-page="-1"
            no-data-text="沒有適用的實驗組">
          </v-data-table>          
          <v-data-table
            v-else
            dense
            :locale="localeTranslate()"
            :headers="headers_book_slots"
            :items="api.book_slots"
            item-key="id"
            :items-per-page="-1"
            no-data-text="No Experiment Available ">
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-dialog v-model="dialog_calendar" fullscreen hide-overlay>
      <v-card>
        <v-toolbar dark color="green">
          <v-btn icon dark @click="dialog_calendar = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ $t("booking.calendar.dialog_title") }}</v-toolbar-title>
          <!--v-spacer></v-spacer-->
        </v-toolbar>
        <Calendar :key="componentKey" :schoolName="api.school_enname" :schoolChiName="api.school_chname"  :schoolLogoUrl="api.school_logo_url" />
      </v-card>
    </v-dialog>
    <router-view @info="schoolInfo" :key="childrenKey" :par="par" ref="mab"></router-view>
  </div>
</template>
<script>

import moment from "moment";

import {api_dds_booking} from '@/services/dds/api_dds_booking';
const apiDDSBooking = new api_dds_booking(process.env.VUE_APP_BASE_URL);

import {api_dds_general} from '@/services/dds/api_dds_general';
const apiDDSGeneral = new api_dds_general(process.env.VUE_APP_BASE_URL);



import Calendar from '@/components/booking/Calendar.vue'

export default {
  name: "experiment",
  components: {
    Calendar
  },
  mixins: [],
  data: function () {
    return {
      selected: null,
      my_schools: [],
      selected_school: null,
      par: "this is pars",
      componentKey: 0,
      childrenKey: 0,
      panel: [0],
      school_code: "",
      role: null,
      drawer: true,
      mini: true,
      dialog: false,
      dialog_calendar: false,
      current:{
        school_code: null,
        username: null,
        uid: null,
        user_level: "STUDENT",
        auth_token: null,
        experiment: null,
        equipment_id: null,
      },
      form: {
        school: "",
        school_code: "",
        experiment: "",
        equipment_id: "",
        next: "",
      },
      api:{
        schools:[],
        experiments:[],
        book_slots: [],
        slots: [],
        school_code: '',
        school_enname: '',
        school_chname: '',
        school_name: '',
        school_chi_name: '',
        school_logo_url: '',
      },
      headers_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'From', value: 'start_at' },
        { text: 'To', value: 'end_at' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '開始', value: 'start_at' },
        { text: '結束', value: 'end_at' },
        { text: '狀態', value: 'status_chi' },
        { text: '操作', value: 'actions', sortable: false },        
      ],
      headers_book_slots: [
        { text: 'Ref', value: 'ref' },
        { text: 'Experiment Set', value: 'experiment_set' },
        { text: 'Date', value: 'date' },
        { text: 'Time', value: 'time' },
        { text: 'Duration (mins)', value: 'duration' },
        { text: 'Status', value: 'status' },
        { text: 'Last Update', value: 'last_update' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
      headers_book_slots_chi: [
        { text: '參考編號', value: 'ref' },
        { text: '實驗組', value: 'experiment_set_chi' },
        { text: '日期', value: 'date' },
        { text: '時間', value: 'time' },
        { text: '時長(分鐘)', value: 'duration' },
        { text: '狀態', value: 'status_chi' },
        { text: '最後更新', value: 'last_update' },
        //{ text: 'Actions', value: 'actions', sortable: false },        
      ],
    };
  },
  created: function () {
    //addEventListener("beforeunload", this.beforeUnloadListener, { capture: true });
  },
  mounted: function () {
    var self = this;

    self.init();
  },
  methods: {
    localeTranslate(){
      var self = this;
      if(self.$i18n.locale=='tc') return 'zh-tw';
      else return 'en';
    },
    init(){
      var self = this;
      self.current.school_code = self.$store.state.user.school_code;
      self.current.username = self.$store.state.user.username;
      self.current.uid = self.$store.state.user.uid;
      self.current.user_level = self.$store.state.user.user_level;
      self.current.auth_token = self.$store.state.user.auth_token;
      if(self.current.user_level != "ADMIN") {    // is student or teacher
        self.form.school_code = self.current.school_code;
        self.getUserAuthSchool();
      }
      else {                                      // is admin
        self.getFullSchoolList();
        if(self.$route.params.school_code == undefined){
          self.form.school_code = self.current.school_code;
          self.$router.push("/booking/"+self.current.school_code);
        }
        else {
          self.form.school_code = self.$route.params.school_code;
          //self.$router.push("/booking/"+self.form.school_code);
        }
      }
      self.getSchoolExperiment();
      if(self.current.user_level!="ADMIN" && self.current.user_level!="TEACHER"){
        self.getOngoingBookSlotsForStudent(self.form.school_code, self.current.uid);
      }
      else {
        self.getOngoingBookSlots(self.form.school_code);
      }
    self.getMyFutureBooking(self.current.uid, self.current.school_code);
    },
    getUserAuthSchool(){
      var self = this;
      apiDDSGeneral.getUserAuthSchool(self.current.school_code, self.current.username, self.current.uid).then((response) => {
        //if(response.status=="success" && self.$route.params.school_code!=response.school){
        //  self.$router.push("/booking/"+response.school+"/");
        //}
        if(response.schools.length < 1){
          self.$store.commit("showSnackBar", "Fail to retrieve school info. Please try again.");
          self.$router.push("/");
        }
        if(self.$route.params.school_code == undefined){
          self.$router.push("/booking/"+response.my_school+"/");
        }
        let hasRight = self.my_schools.find(school => school.school === self.$route.params.school_code);
        if(hasRight == undefined){
          self.$router.push("/booking/"+response.my_school+"/");
        }
        
      });
    },
    selectLabel(label){
      var self = this;
      if(self.$i18n.locale=='tc'){
        if (label=='label') return "請選擇學校ID"
        else if (label=='schools') return "code_chname"
      }
      else {
        if (label=='label') return "Please select a School ID";
        else if (label=='schools') return "code_enname";
      }
    },
    schoolInfo({school_code, school_enname, school_chname, school_logo_url}){
      var self = this;
      self.api.school_code = school_code;
      self.api.school_enname = school_enname;
      self.api.school_chname = school_chname;
      self.api.school_logo_url = school_logo_url;
      self.selected_school = self.api.school_code;
    },
/*    getUserSchool(){
      var self = this;
      apiGeneral.getUserSchool(self.$cookies.get('username')).then((response) => {
        if(response.status=="success" && self.$route.params.school_code!=response.school){
          self.$router.push("/booking/"+response.school+"/");
        }
      });
    },
*/
    isBookedByMe: function (slot) {
      if ( (slot.current==true && (slot.status == "RESERVED"||slot.status == "SUSPENDED") && (slot.uid == this.$cookies.get("uid"))) ) {
        return true;
      }
      else {
        return false;
      }
    },    
    isOverrided(slot){
      if (slot.eStatus=="HOLD" && !slot.passed) {
        return true;
      } 
      else {
        return false;
      }
    },
    isBookedSoon: function (slot) {
      if ( slot.current==false && ( slot.status == "RESERVED" || slot.status == "SUSPENDED" || slot.status == "MAINTENANCE") && slot.uid == this.$cookies.get("uid") ) {
        return true;
      }
      else {
        return false;
      }
    },
    enterLab: function (booking_id, experiment, equipment_id, role, override, user_level) {
      var self = this;
      if(override == "1" && role == "player"){
        self.$store.commit("showSnackBar", "This Booking is overriding by incharge/admin, please try entering later.");        
      }
      else {
        apiDDSBooking
          .enterLab(booking_id, self.$cookies.get("uid"), self.current.school_code, experiment, equipment_id, self.$cookies.get("auth_token"), role, user_level)
          .then((response) => {
            if (response.status == "fail") {
              self.$store.commit("showSnackBar", response.message);
            } else {
              if(self.$i18n.locale=='tc')
                self.$store.commit("showSnackBar", "準備中...");
              else
                self.$store.commit("showSnackBar", "Preparing...");
              self.$cookies.set("session_token", response.session_token);
              self.$cookies.set("role", role);
              self.$cookies.set("school_code", self.current.school_code);
              self.$cookies.set("experiment", experiment);
              self.$cookies.set("equipment_id", equipment_id);
              self.$cookies.set("end_at", response.end_at);
              self.$cookies.set("booking_id", booking_id);
              self.$router.push(
                "/iot_experiment/" + self.current.school_code + "/" + experiment.toLowerCase() + "/" + equipment_id
              );
            }
          });
      }
    },
    releaseSlot: function (slot_id) {
      var self = this;
      apiDDSBooking
        .releaseSlot(slot_id, self.$cookies.get("uid"), self.$cookies.get("auth_token"))
        .then((response) => {          
          if (response.status == "fail") {            
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", response.message_chi);
            } else {
              self.$store.commit("showSnackBar", response.message);
            }
          } else {            
            if (self.$i18n.locale=='tc') {
              self.$store.commit("showSnackBar", response.message_chi);
            } else {
              self.$store.commit("showSnackBar", response.message);
            }
            //location.reload();
            self.$refs.mab.getSlotsByDate();
            self.getMyFutureBooking(self.current.uid, self.current.school_code);
          }
        });
    },    
    getFullSchoolList(){
      var self = this;
      apiDDSGeneral.getFullSchoolList()
        .then((response) => {
          self.api.schools = response.schools;
      });
    },
    getSchoolExperiment(){
      var self = this;
      apiDDSGeneral.getSchoolExperiment(self.form.school_code)
      .then((response) => {
          self.api.experiments = response.experiments;
      });
    },
    getMyFutureBooking(uid, school_code){
      var self = this;
      apiDDSBooking.getMyFutureBooking(uid, school_code)
      .then((response) => {
          self.api.slots = response.slots;
      });
    },    
    getOngoingBookSlots(school_code){
      var self = this;
      apiDDSGeneral.getOngoingBookSlots(school_code)
      .then((response) => {
          self.api.book_slots = response.book_slots;
      });
    },
    getOngoingBookSlotsForStudent(school_code, uid){
      var self = this;
      apiDDSGeneral.getOngoingBookSlotsForStudent(school_code, uid)
      .then((response) => {
          self.api.book_slots = response.book_slots;
      });
    },
    viewBookSlots(item){
      var self = this;
      self.$cookies.set('experiment', item.experiment);
      self.equipment_id = self.$cookies.set('equipment_id', item.equipment_id);
      self.$router.push("/school/history/"+self.school_code+"/"+item.experiment+"/"+item.equipment_id);
    },
    back(){
      var self = this;
      self.$cookies.remove("experiment");
      self.$cookies.remove("equipment_id");
      if(self.$route.name == 'admin-school-management'){
        self.$router.push("/admin/management/school/school_list");
      }
      else {
        self.$router.push("/school/school_list");
      }
    },
    goTo(school_code){
      var self = this;
      self.$router.push("/booking/"+school_code);
      self.init();      
      self.componentKey+=1;
      self.childrenKey+=1;
    },
    /*beforeUnloadListener(event) {
      console.log("beforeUnloadListener");
      event.preventDefault();
      return (event.returnValue = "qwer");
    },
    beforeUnloadListener2(event) {
      console.log("beforeUnloadListener2");
      event.preventDefault();
      return (event.returnValue = "");
    },*/
  },
  beforeDestroy() {
  /*  alert("beforeDestroy");
    removeEventListener("beforeunload", this.beforeUnloadListener2, {
      capture: true,
    });
    */
  },
  destroyed(){
    clearInterval(this.kick_inte);
    console.log("destroyed");
  }
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>